import { useTranslation } from 'react-i18next';

import Checkbox from '@/components/ui/Checkbox/Checkbox';
import { PaymentDeviceAccessory } from '@/models/common/PaymentDeviceEnums';
import { accessoriesText, missingAccessories, toggleAccessory } from '@/helpers/paymentDeviceAccessories';

interface AccessoriesFieldProps {
  label: string;
  /** The items to tick: all four at hand-over, what went out at return. */
  options: PaymentDeviceAccessory[];
  value: PaymentDeviceAccessory[];
  onChange: (value: PaymentDeviceAccessory[]) => void;
  /** At return: say live which of the options are not ticked. */
  warnMissing?: boolean;
}

/** The accessories that go out with a terminal at hand-over, or come back with it at return (HAT-1434). */
const AccessoriesField = ({ label, options, value, onChange, warnMissing = false }: AccessoriesFieldProps) => {
  const { t } = useTranslation();
  const missing = warnMissing ? missingAccessories(options, value) : [];

  return (
    <div className="flex flex-col gap-2" role="group" aria-label={label}>
      <span className="body-sm-semibold text-(--font-secondary)">{label}</span>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {options.map((item) => (
          <label key={item} className="flex items-center gap-2 cursor-pointer body-sm-regular">
            <Checkbox checked={value.includes(item)} onCheckedChange={(on) => onChange(toggleAccessory(value, item, on))} />
            <span>{t(`paymentDevices.accessories.${item}`)}</span>
          </label>
        ))}
      </div>
      {missing.length > 0 && (
        <p role="status" className="m-0 rounded-lg bg-[#fdecec] text-[#7a1d1d] px-3 py-2 body-sm-regular">
          {t('paymentDevices.accessories.missing', { items: accessoriesText(missing, t) })}
        </p>
      )}
    </div>
  );
};

export default AccessoriesField;
